
import CommonMixin from '@/core/pages/CommonMixin';
import moment from 'moment';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Booking } from '@/models/bookings';
import LottieAnimation from 'lottie-web-vue';
import booking_animation from '@/assets/animations/booking_logo.json';

@Component({
  components: {
    LottieAnimation,
  },
})
export default class BookingLogo extends CommonMixin {
  dots = 4;

  @Prop() readonly booking: Booking;
  @Prop({ default: true }) readonly animation: boolean;

  booking_animation = booking_animation;

  getBookingDayName(date: string): string {
    return moment(date).locale(this.getUserLanguage).format('ddd');
  }

  getBookingDay(date: string): number {
    return moment(date).date();
  }

  getBookingMonth(date: string): string {
    return moment(date).locale(this.getUserLanguage).format('MMMM').substring(0, 3) + " '" + moment(date).format('YY');
  }

  getBookingTime(date: string): string {
    return moment(date).format('HH:mm');
  }
}
